import { useNavigate } from './hooks';

// Static landing page. **No SpacetimeDB connection.** The CTA navigates to
// `/play`, where the SessionGuard takes over and decides what to render
// (identity picker / connect / canopy entry / game / banned).
export function LandingPage() {
  const navigate = useNavigate();
  return (
    <div
      style={{
        height: '100vh',
        width: '100vw',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        background:
          'radial-gradient(circle at 50% 35%, #1a2438 0%, #0a0e18 70%)',
        color: '#e7d9b6',
        fontFamily: 'Georgia, serif',
        textAlign: 'center',
      }}
    >
      <div style={{ maxWidth: 540, padding: 24 }}>
        <h1
          style={{
            fontSize: 64,
            margin: 0,
            letterSpacing: 2,
            fontWeight: 400,
          }}
        >
          Heartwood
        </h1>
        <p
          style={{
            fontSize: 18,
            opacity: 0.75,
            marginTop: 8,
            marginBottom: 36,
            fontStyle: 'italic',
          }}
        >
          A small world of trees and squirrels chasing each other up them.
        </p>
        <button
          onClick={() => navigate('/play')}
          style={{
            background: '#e09020',
            color: '#1a1208',
            border: 'none',
            padding: '14px 36px',
            fontSize: 18,
            borderRadius: 6,
            cursor: 'pointer',
            fontFamily: 'inherit',
            letterSpacing: 0.5,
          }}
        >
          Enter the canopy →
        </button>
      </div>
    </div>
  );
}
